import "../../App.css";
import Sidebar from "../Sidebar";
import "../../styles/login.css";
import { withRouter } from "react-router-dom";
import React, { useState, useEffect } from "react";
import axios from "axios";
import UserTab from "../UserTab";
import Table from "../Table";
import Moment from "moment";
import Parametros from "../Parametros";
import CurrentUser from "../CurrentUser";
import EliminarElemento from "../EliminarElemento";
import EmptyTableRow from "../EmptyTableRow";
function PersonaEmpresa(props) {
  const { history } = props;
  const [filtrador, setFiltrador] = useState(0);
  // eslint-disable-next-line
  const [ip, setIP] = useState("");
  const [update, setUpdate] = useState(false);
  const [personaEmpresaStateUpdate, setpersonaEmpresaStateUpdate] = useState(
    []
  );
  // eslint-disable-next-line
  const [usuario, setUsuario] = useState(CurrentUser.user);

  const [formularioState, setFormularioState] = useState({
    mail: "",
    username: "",
    first_name: "",
    lastname: "",
    // last_login: "",
    ip_crea: "",
    created_at: "",
    valid_until: "",
    is_active: true,
    profiles: "",
  });
  const [personaEmpresaState, setpersonaEmpresaState] = useState([]);
  const [formularioUpdate, setformularioUpdate] = useState({});

  const [editable, setEditable] = useState({
    id: "",
  });

  const [paginacionState, setPaginacionState] = useState({
    limit: 5,
    skip: 1,
  });

  const totalPaginas = Math.max(
    1,
    Math.ceil(personaEmpresaState.length / paginacionState.limit)
  );

  const paginatedRows = personaEmpresaState.slice(
    (paginacionState.skip - 1) * paginacionState.limit,
    paginacionState.skip * paginacionState.limit
  );

  let handleStageForm = (event) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;

    setFormularioState({
      ...formularioState,
      [event.target.name]: value,
    });
  };

  let crearpersonaEmpresa = async (event) => {
    event.preventDefault();
    if (usuario.permisos.indexOf("Crear") > -1) {
      if (window.confirm("¿Esta seguro que deseas agregar este elemento?")) {
        // aqui deberia ir el delete segun response eliminar de la lista de react
        let objetoUpdate = {
          first_name: formularioState.first_name,
          mail: formularioState.mail,
          lastname: formularioState.lastname,
          valid_until: new Date(formularioState.valid_until)
            .toISOString()
            .slice(0, 10),
          is_active: formularioState.is_active,
        };

        let response = await fetch(Parametros.post + "user/", {
          method: "POST",
          headers: {
            Authorization: "Bearer " + usuario.key,
            Accept: "application/json",
            "Content-Type": "application/json",
            Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
          },
          body: JSON.stringify(objetoUpdate),
        });

        let responseJson = await response.json();

        if (response.status === 200 || response.status === 201) {
          setUpdate(!update);
          alert("ok");
          setEditable({});
          document.getElementById("formularioBusqueda").reset();
        } else if (response.status === Parametros.loginTokenExcept) {
          alert(Parametros.loginTokenExceptMessage);
          history.push({
            pathname: "/",
          });
        } else {
          alert(responseJson.detail);
        }
      } else {
        // Do nothing!
        setpersonaEmpresaState(
          JSON.parse(JSON.stringify(personaEmpresaStateUpdate))
        );
        setEditable({});
      }
    } else {
      alert(usuario.crear);
    }
  };

  let personaEmpresaHandleChange = (index, e) => {
    const target = e.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = e.target.getAttribute("name");

    let newList = personaEmpresaState;
    newList[index][name] = value;
    setpersonaEmpresaState(JSON.parse(JSON.stringify(newList)));

    let estadoUpdate = formularioUpdate;
    estadoUpdate[name] = value;

    setformularioUpdate(JSON.parse(JSON.stringify(estadoUpdate)));
  };
  const getData = async () => {
    const res = await axios.get("https://geolocation-db.com/json/");
    setIP(res.data.IPv4);
  };
  useEffect(() => {
    async function llamadaApi() {
      let response = await fetch(
        Parametros.urlApi + "users/?skip=0&limit=100&is_mantenedor=true",
        {
          method: "GET",
          headers: {
            Authorization: "Bearer " + usuario.key,
            Accept: "application/json",
          },
        }
      );
      let responseJson = await response.json();

      if (response.status === 200 || response.status === 201) {
        let responseJsonUpdate = JSON.stringify(responseJson);
        let responseJsonstate = JSON.stringify(responseJson);
        setpersonaEmpresaStateUpdate(JSON.parse(responseJsonUpdate));
        setpersonaEmpresaState(JSON.parse(responseJsonstate));
        getData();
      } else if (response.status === Parametros.loginTokenExcept) {
        alert(Parametros.loginTokenExceptMessage);
        history.push({
          pathname: "/",
        });
      }
    }

    llamadaApi();
  }, [update, history, usuario]);
  let guardarUnidadEditada = async (item, index) => {
    if (usuario.permisos.indexOf("Editar") > -1) {
      if (window.confirm("¿Esta seguro de editar este elemento?")) {
        // aqui deberia ir el delete segun response eliminar de la lista de react

        let response = await fetch(
          Parametros.urlApi + "users/" + parseInt(item.user_id),
          {
            method: "PUT",
            body: JSON.stringify(formularioUpdate),
            headers: {
              Authorization: "Bearer " + usuario.key,
              Accept: "application/json",
              "Content-Type": "application/json",
              Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
            },
          }
        );
        let responseJson = await response.json();

        if (response.status === 200 || response.status === 201) {
          setUpdate(!update);
          setEditable({});
          alert(responseJson.message);
        } else if (response.status === Parametros.loginTokenExcept) {
          alert(Parametros.loginTokenExceptMessage);
          history.push({
            pathname: "/",
          });
        } else {
          alert(responseJson.detail);
        }
      } else {
        // Do nothing!
        setpersonaEmpresaState(
          JSON.parse(JSON.stringify(personaEmpresaStateUpdate))
        );
      }
    } else {
      alert(usuario.editar);
    }
  };
  let cancelarEdicion = () => {
    setpersonaEmpresaState(
      JSON.parse(JSON.stringify(personaEmpresaStateUpdate))
    );
    setEditable({});
  };
  let editar = (id) => {
    setpersonaEmpresaState(
      JSON.parse(JSON.stringify(personaEmpresaStateUpdate))
    );
    setEditable(id);
    setformularioUpdate({});
  };
  let asignarPerfil = (item) => {
    if (usuario.permisos.indexOf("Editar") > -1) {
      history.push({
        pathname: "/AsignacionPerfiles",
        state: {
          mail: item,
        },
      });
    } else {
      alert(usuario.editar);
    }
  };
  return (
    <div className="App">
      <Sidebar tipo="2"></Sidebar>
      <br />
      <div className="container">
        <UserTab nombre={"Usuarios"}></UserTab>
        <br></br>
        {/* <h1>Usuarios</h1> */}
        <form id="formularioBusqueda" onSubmit={crearpersonaEmpresa}>
          <div className="col-md-4">
            <h5>Mail</h5>
            <input
              type="email"
              onChange={handleStageForm}
              name="mail"
              required
              className="form-control"
            ></input>
          </div>

          <div className="col-md-4">
            <h5>Nombre</h5>
            <input
              onChange={handleStageForm}
              name="first_name"
              required
              className="form-control"
            ></input>
          </div>

          <div className="col-md-4">
            <h5>Apellido</h5>
            <input
              onChange={handleStageForm}
              name="lastname"
              required
              className="form-control"
            ></input>
          </div>

          {/* <div className='col-md-4'>
            <h5>Ultima coneccion </h5>
            <input onChange={handleStageForm} type="date" name='last_login' required className="form-control"></input>
          </div> */}

          {/* <div className='col-md-4'>
            <h5>Fecha creacion</h5>
            <input onChange={handleStageForm} type="datetime-local" name='created_at' required className="form-control"></input>
          </div> */}

          <div className="col-md-4">
            <h5>Fecha de expiración</h5>
            <input
              type="date"
              onChange={handleStageForm}
              name="valid_until"
              required
              className="form-control"
            ></input>
          </div>

          <div className="col-md-4">
            <h5>Activo</h5>
            <input
              checked={formularioState.is_active}
              onChange={handleStageForm}
              type="checkbox"
              name="is_active"
              className="form-control c1"
            ></input>
          </div>

          <div className="col-md-4">
            <br />
            <button
              type="submit"
              value="Submit"
              style={{ margin: "14px 0px" }}
              id="btnBuscar"
              className="form-control button brEdit btn-primary"
            >
              Agregar
            </button>
          </div>
        </form>
        <div
          className="col-md-12 table-responsive"
          style={{ width: "100%" }}
        >
          <Table
            type={1}
            paginationBelow={true}
            paginas={totalPaginas}
            paginadorState={paginacionState}
            setPaginadoor={setPaginacionState}
            filtrador={filtrador}
            propsetFiltrador={setFiltrador}
            elementos={[
              "Correo",
              "Nombre",
              "Apellido",
              "Fecha Creación",
              "Fecha de expiración",
              "Activo",
            ]}
          ></Table>
          <table className="table table-bordered" id="myTable">
            <Table
              type={2}
              filtrador={filtrador}
              propsetFiltrador={setFiltrador}
              elementos={[
                "Correo",
                "Nombre",
                "Apellido",
                "Fecha Creación",
                "Fecha de expiración",
                "Activo",
              ]}
            ></Table>

            {usuario.permisos.indexOf("Ver") > -1 ? (
              <tbody className="ajusteTabladata">
                {paginatedRows.length === 0 && (
                  <EmptyTableRow colSpan={20} />
                )}
                {paginatedRows.map((item, index) => {
                  return (
                    <tr key={item.user_id}>
                      {editable === item.user_id ? (
                        <>
                          <td>{item.user_id}</td>
                          {/* <td>{item.mail} </td> */}
                          <td>
                            <input
                              value={item.mail}
                              name="mail"
                              type="mail"
                              onChange={(event) => {
                                personaEmpresaHandleChange(index, event);
                              }}
                              className="form-control"
                            ></input>
                          </td>
                          <td>
                            <input
                              value={item.first_name}
                              name="first_name"
                              onChange={(event) => {
                                personaEmpresaHandleChange(index, event);
                              }}
                              className="form-control"
                            ></input>
                          </td>
                          <td>
                            <input
                              value={item.lastname}
                              name="lastname"
                              onChange={(event) => {
                                personaEmpresaHandleChange(index, event);
                              }}
                              className="form-control"
                            ></input>
                          </td>
                          {/* <td ><input value={item.ip_crea} name='ip_crea' onChange={(event) => { personaEmpresaHandleChange(index, event) }} className='form-control'></input></td> */}
                          {/* <td ><input type="date" value={item.created_at} name='created_at' onChange={(event) => { personaEmpresaHandleChange(index, event) }} className='form-control'></input></td> */}
                          <td>
                            {Moment(item.created_at).format("DD-MM-YYYY")}
                          </td>
                          <td>
                            <input
                              value={item.valid_until}
                              type="date"
                              name="valid_until"
                              onChange={(event) => {
                                personaEmpresaHandleChange(index, event);
                              }}
                              className="form-control"
                            ></input>
                          </td>
                          <td>{item.is_active ? "Activo" : "Inactivo"}</td>

                          <td>
                            <abbr title="Confirmar Edición">
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  guardarUnidadEditada(item, index);
                                }}
                                className="glyphicon glyphicon glyphicon-ok"
                              >
                                {" "}
                              </span>
                            </abbr>
                            <abbr title="Cancelar Edición">
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  cancelarEdicion();
                                }}
                                className="glyphicon glyphicon-share-alt"
                              ></span>
                            </abbr>
                          </td>
                        </>
                      ) : (
                        <>
                          <td>{item.user_id}</td>

                          <td>{item.mail} </td>
                          <td>{item.first_name}</td>
                          <td>{item.lastname} </td>
                          {/* <td>{item.ip_crea} </td> */}
                          <td>
                            {Moment(item.created_at).format("DD-MM-YYYY")}
                          </td>
                          <td>
                            {Moment(item.valid_until).format("DD-MM-YYYY")}{" "}
                          </td>
                          <td>{item.is_active ? "Activo" : "Inactivo"}</td>

                          <td>
                            <abbr title="Editar Elemento">
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  editar(item.user_id);
                                }}
                                className="glyphicon glyphicon-pencil"
                              >
                                {" "}
                              </span>
                            </abbr>
                            <abbr title="Asignar Perfil">
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  asignarPerfil(item.mail);
                                }}
                                className="glyphicon glyphicon-plus "
                              ></span>
                            </abbr>

                            <EliminarElemento
                              method="PUT"
                              endpoint={`user/active/${item.user_id}?active=false`}
                              onSuccess={() => {
                                setUpdate(!update);
                              }}
                            />
                          </td>
                        </>
                      )}
                    </tr>
                  );
                })}
              </tbody>
            ) : (
              <tbody>
                <td>{usuario.ver}</td>
              </tbody>
            )}
          </table>
          <Table
            type={3}
            paginas={totalPaginas}
            paginadorState={paginacionState}
            setPaginadoor={setPaginacionState}
          />
          {!usuario.permisos.indexOf("Ver") < -1 && usuario.ver}
        </div>
      </div>
      {/* {stateUptade &&
        <>
          <div className='container'>
            <div className='col-md-12'>
              <div className='col-md-3 col-md-offset-7' >
                <button className='btn btn-primary' onClick={() => { confirmarEliminacion() }}>Confrimar Actualizacion</button>
              </div>
              <div className='col-md-2'>
                <button className='btn btn-primary' onClick={() => { cancelarEliminacion() }}>Revertir cambios</button>
              </div>
            </div>
          </div>
        </>


      } */}
    </div>
  );
}

export default withRouter(PersonaEmpresa);
